import { Spinner } from "react-bootstrap";
import Logo from "../assets/logo2.png";

const Loading = ({
  texto = "Carregando...",
  descricao = "Aguarde alguns instantes...",
}) => {
  return (
    <div
      className="loading-overlay"
      role="dialog"
      aria-modal="true"
      aria-label={texto}
    >
      <div className="loading-card">
        <img
          src={Logo}
          alt="Expresso Embaixador"
          width={145}
          className="d-block mx-auto mb-4"
        />

        <Spinner
          animation="border"
          variant="primary"
          role="status"
          style={{
            width: "2.75rem",
            height: "2.75rem",
          }}
        >
          <span className="visually-hidden">{texto}</span>
        </Spinner>

        <h5 className="fw-bold mt-4 mb-1">{texto}</h5>

        {descricao && <p className="small text-muted mb-0">{descricao}</p>}
      </div>
    </div>
  );
};

export default Loading;
